import { createTheme } from "@mui/material/styles";

const grey = {
  50: "#fdfdfe",
  100: "#fbfbfe",
  200: "#f7f8fc",
  300: "#f4f4fb",
  400: "#f0f1f9",
  500: "#ecedf8",
  600: "#b8b9c1",
  700: "#86878d",
  800: "#58585c",
  900: "#2d2e2f",
  950: "#1a1a1b",
};

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#00FF4F" },
    background: { default: grey[950], paper: "#151617" },
    text: { primary: "#ffffff", secondary: "rgba(255,255,255,0.85)" },
    grey,
  },
  breakpoints: {
    values: { xs: 0, sm: 390, md: 768, lg: 1440, xl: 1920 },
  },
  typography: {
    fontFamily: ['Poppins', 'system-ui', 'Segoe UI', 'Roboto', 'Arial'].join(','),
    h1: { fontWeight: 800, letterSpacing: -0.2 },
    h2: { fontWeight: 800 },
    h3: { fontWeight: 700 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiContainer: { defaultProps: { maxWidth: "lg" } },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 999, paddingInline: 20 },
        // contained="primary"
        containedPrimary: {
          backgroundColor: "#00FF4F",
          color: "#000",
          "&:hover": { backgroundColor: "#00e645" },
        },
        // outlined="primary"
        outlinedPrimary: {
          borderColor: "#00FF4F",
          color: "#00FF4F",
          "&:hover": { borderColor: "#00e645", color: "#00e645" },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        html: { scrollBehavior: "smooth" },
        body: { backgroundColor: grey[950] },
        "#o-que-fazemos, #quem-somos, #cases, #contato": {
          scrollMarginTop: 0,
        },
      },
    },
  },
});

export default theme;